import script from "./liveItem.vue?vue&type=script&setup=true&name=liveItem&lang=js"
export * from "./liveItem.vue?vue&type=script&setup=true&name=liveItem&lang=js"

import "./liveItem.vue?vue&type=style&index=0&id=5559dbd2&scoped=true&lang=css"

import exportComponent from "D:\\Jawsro\\company\\虎鲸\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5559dbd2"]])

export default __exports__